module.exports = __webpack_public_path__ + "static/media/talk04_medium@2x.4e5ecebe.jpg";